var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "18px",
    viewBox: "0 0 14 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "561C137C-35EA-4BAC-8ADE-8BA2FC1B7CFC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u2705-3-1---Creating-An-Alert",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3-1-5---Creating-An-Alert",
    transform: "translate(-1397.000000, -677.000000)",
    fill: "#081981"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04.-Buttons/02.-Secondary-Button/02.-Small/03.-Icon/01.-Inactive",
    transform: "translate(1392.000000, 674.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03.-Icons/ic_plus_circle",
    transform: "translate(5.681818, 3.875000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.20000001,8.53541667 C10.6841308,8.53541667 12.6979167,10.5492026 12.6979167,13.0333333 L12.6979167,13.0333333 L12.6979167,15.8666667 C12.6979167,16.4730293 12.2063626,16.9645834 11.6,16.9645834 L11.6,16.9645834 L1.39999998,16.9645834 C0.793637351,16.9645834 0.302083316,16.4730293 0.302083316,15.8666667 L0.302083316,15.8666667 L0.302083316,13.0333333 C0.302083316,10.5492026 2.31586921,8.53541667 4.79999999,8.53541667 L4.79999999,8.53541667 Z M8.20000001,9.59791667 L4.79999999,9.59791667 C2.90267175,9.59791667 1.36458332,11.1360051 1.36458332,13.0333333 L1.36458332,13.0333333 L1.36458332,15.8666667 C1.36458332,15.8862268 1.3804399,15.9020834 1.39999998,15.9020834 L1.39999998,15.9020834 L11.6,15.9020834 C11.6195601,15.9020834 11.6354167,15.8862268 11.6354167,15.8666667 L11.6354167,15.8666667 L11.6354167,13.0333333 C11.6354167,11.1360051 10.0973282,9.59791667 8.20000001,9.59791667 L8.20000001,9.59791667 Z M6.5,0.0354166419 C8.67116943,0.0354166419 10.43125,1.79549722 10.43125,3.96666665 C10.43125,6.13783608 8.67116943,7.89791666 6.5,7.89791666 C4.32883057,7.89791666 2.56874999,6.13783608 2.56874999,3.96666665 C2.56874999,1.79549722 4.32883057,0.0354166419 6.5,0.0354166419 Z M6.5,1.09791664 C4.91563312,1.09791664 3.63124999,2.38229977 3.63124999,3.96666665 C3.63124999,5.55103353 4.91563312,6.83541666 6.5,6.83541666 C8.08436688,6.83541666 9.36875001,5.55103353 9.36875001,3.96666665 C9.36875001,2.38229977 8.08436688,1.09791664 6.5,1.09791664 Z",
    id: "Combined-Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcProfile);
export default __webpack_public_path__ + "static/media/ic_profile.bbc1915a8769f46b29dc92953a87ceab.svg";
export { ForwardRef as ReactComponent };